import React, { RefObject } from 'react'
import { connect } from 'react-redux'
import { ISEOSearch } from '../../types/ISearchFilterParams'
import withComponentTranslation from '../../utils/translatorHOC'
import vi from './vi.json'
import JobHeadStyles from './JobHead.css'
import { EPageTab } from '../../types/EPageTag'
import { initialDataProvider } from '@microfrontends/app-shell-v2'
import { ELanguage, dateToString } from '@microfrontends/react-components'
import { TSelectDataItem } from '@microfrontends/react-components/components/types'

export interface IJobHeadProps {
    searchResults: any
    searchConditions: any
    metaCategory: any
    language: string
    translate: (term: string) => string
    seoSearch: ISEOSearch
    showJobAlertModal: boolean
    onCloseJobAlertModal: () => void
    stopShowFloatingRef: RefObject<HTMLDivElement>
    isOnCompanyProfiles: boolean
    pageTab: EPageTab
}

export interface IJobHeadStates {
    isMobile: boolean
    isMobile768: boolean
    showSort: boolean
}

class SearchStatus extends React.Component<IJobHeadProps, IJobHeadStates> {
    oldParams: any

    /**
     * 648 Jobs matches in IT - Software jobs now hiring in Ho Chi Minh
     */
    constructor(props) {
        super(props)
        this.state = {
            isMobile: false,
            isMobile768: false,
            showSort: false
        }
    }

    renderJobCounting = () => {
        const { translate, seoSearch, searchConditions, searchResults, language } = this.props
        // Location
        const locationIdList: number[] = []
        seoSearch.location &&
            seoSearch.location.map((item) => {
                locationIdList.push(item.id)
            })
        // Category
        const categoryIdList: number[] = []
        seoSearch.category &&
            seoSearch.category.map((item) => {
                categoryIdList.push(item.id)
            })
        const isWebBrowser = typeof window !== 'object'
        const searchData =
            seoSearch && isWebBrowser
                ? {
                      categoryId: categoryIdList,
                      locationId: locationIdList,
                      userId: 0, // TODO still need to find employer id
                      nbHits: (seoSearch.searchResultData && seoSearch.searchResultData.nbHits) || 0,
                      totalJobsText:
                          (seoSearch.searchResultData && seoSearch.searchResultData.totalJobsText) || ''
                  }
                : searchConditions

        let noOfJobs = searchResults.nbHits ?? searchData.nbHits ?? 0
        const totalJobsText = searchResults.totalJobsText ?? searchData.totalJobsText ?? ''
        const jobCountDisplayText = totalJobsText || `${noOfJobs}`

        if (typeof window === 'undefined') {
            noOfJobs = seoSearch.jobCounts ?? 0
        }

        // search Job Keyword
        const searchedKeyword: string = searchResults.query || ''

        const locationIds = (seoSearch.location || []).map((item) => item.id) || []

        const locationNames = initialDataProvider.getLocationNameFromIds(locationIds)
        const locationText = locationNames.map((item: TSelectDataItem) =>
            language === ELanguage.VI ? item.name : item.nameEn
        )
        const districtName = seoSearch.districtName

        const nowTimeInString = dateToString(null)

        const renderHeadTitle = () => {
            const isManagementJob = this.props.pageTab === EPageTab.MANAGEMENT_JOBS

            if (noOfJobs === 0) {
                return <>{translate('job matched')}</>
            }

            let isRenderMoreDetail = searchedKeyword === ''
            if (locationIds.length > 1 || (searchedKeyword === '' && locationIds.length === 0)) {
                isRenderMoreDetail = false
            }

            if (!isRenderMoreDetail) {
                return (
                    <>
                        {isManagementJob ? (
                            <> {translate(`management job${noOfJobs > 1 ? 's' : ''}`)}</>
                        ) : (
                            translate(`job${noOfJobs > 1 ? 's' : ''}`)
                        )}
                        {searchedKeyword ? (
                            <strong title={searchedKeyword}>&nbsp;&quot;{searchedKeyword}&quot;</strong>
                        ) : (
                            ''
                        )}{' '}
                        {translate('matched')}
                    </>
                )
            }

            return (
                <>
                    {translate(`job${noOfJobs > 1 ? 's' : ''}`)} {translate('at')}{' '}
                    {districtName ? districtName + `,` : ''} {locationText} {translate('matched')},{' '}
                    {translate('updated on')} {nowTimeInString}
                </>
            )
        }

        return (
            <span className='animated fadeIn'>
                <div className='wrapper-job-criteria'>
                    <h1 className='job-matched'>
                        <span className='no-of-jobs'>
                            <strong>{`${jobCountDisplayText} `}</strong>
                        </span>
                        {renderHeadTitle()}
                    </h1>
                </div>
            </span>
        )
    }

    render() {
        const { isOnCompanyProfiles } = this.props
        const jobCounting = this.renderJobCounting()

        return (
            <JobHeadStyles>
                <div
                    className='container-fluid job-head-component search-status d-lg-none'
                    style={{ margin: !isOnCompanyProfiles ? '16px 0' : '0' }}
                >
                    <div className='job-counting row align-items-center no-gutters'>
                        <div className='col-12'>{jobCounting}</div>
                    </div>
                </div>
            </JobHeadStyles>
        )
    }
}

const mapStateToProps = (state) => {
    const searchResults = state.searchFilter.searchResult || {}
    const searchConditions = state.searchFilter.lastParams || {}
    const metaCategory = state.searchFilter.selectData || {}
    return { searchResults, searchConditions, metaCategory, pageTab: state.globalMisc.pageTab }
}

const componentWithTranslation = withComponentTranslation(vi)(SearchStatus)

export default connect(mapStateToProps)(componentWithTranslation)
